module.exports = __webpack_public_path__ + "static/images/green-box-lg.86f21ea16.png";